import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-panier-product',
  templateUrl: './panier-product.component.html',
  styleUrls: ['./panier-product.component.css']
})
export class PanierProductComponent implements OnInit {

  @Input() item:any;
  constructor() {}

  ngOnInit(): void {}

  changeQte(qte,item)
  {
    console.log(qte);
    console.log(item);
  }

}
